import styled, { keyframes } from "styled-components";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  p#text-upload {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    padding: 0 5px;
    
    justify-content: center;

    svg {
      margin-left: 10px;
      font-size: 30px;
    }
  }
`;

export const DropZone = styled.div`
  width: 100%;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 2px;
  cursor: pointer;
  -webkit-transition: border-color 0.3s;
  transition: border-color 0.3s;

  padding: 15px 0;

  &:hover {
    border-color: #1890ff;
  }

  p {
    margin: 0;
  }
`;

export const LoadingWrapper = styled.div`
  margin: 5px;
  text-align: center;
  vertical-align: middle;

  svg {
    animation: ${rotate360} 1s linear infinite;
    margin-right: 5px;
  }
`;

export const SuccessWrapper = styled.div`
  margin: 5px;
  text-align: center;
  vertical-align: middle;

  svg {
    margin-right: 5px;
  }
`;

export const FileList = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #f9f9f9;

    span {
      flex-grow: 1;
      margin-left: 8px;
      font-size: 14px;
      color: #333;
    }

    svg {
      cursor: pointer;
      margin-left: 8px;
      color: #d9534f;
      &:hover {
        color: #c9302c;
      }
    }
  }
`;

export const UploadProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;

  .progress-bar {
    flex: 1;
    height: 6px;
    background: #e9ecef;
    border-radius: 3px;
    overflow: hidden;
  }

  .progress-fill {
    height: 100%;
    background: #1890ff;
    transition: width 0.2s;
  }

  span {
    font-size: 12px;
    color: #666;
    min-width: 36px;
  }
`;

export const UploadQueueItem = styled.div`
  padding: 12px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  margin-bottom: 8px;
  background: ${({ status }) => (status === "error" ? "#fff5f5" : "#fafafa")};

  .file-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .file-size {
    color: #666;
    margin-left: 8px;
  }

  .progress-row {
    margin-bottom: 8px;
  }

  .status-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .status-label {
    font-size: 12px;
    color: #666;
  }

  .status-error {
    font-size: 12px;
    color: #d9534f;
  }

  .btn-cancel,
  .btn-remove {
    font-size: 12px;
    padding: 4px 8px;
    border: none;
    background: transparent;
    color: #1890ff;
    cursor: pointer;
  }

  .btn-cancel:hover,
  .btn-remove:hover {
    text-decoration: underline;
  }
`;

export const UploadQueueList = styled.div`
  margin-top: 12px;
`;

export const WarningMessage = styled.div`
  margin-top: 8px;
  font-size: 13px;
  color: #d9534f;
`;

export const UploadInfoNotice = styled.div`
  margin-bottom: 12px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  color: #0050b3;
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
`;
